<template>
  <div class="col-12 col-lg-6">
    <div class="tit text-center">
      <h1>Estado Civil</h1>
    </div>
    <div class="row justify-content-center">
      <div class="col-12 col-md-10 col-lg-8 col-xl-7">
        <form @submit="onSubmit">
          <div class="form-group text-left">
            <label for="EstadoCivil">
            Estado Civil
            </label>
            <at-select v-model="currentUser.Social.EstadoCivil" filterable size="large" placeholder="Selecione...">
              <at-option v-for="(marital, index) in optionsMarital" :key="`maritalOptions${index}`" :value="marital.value">{{marital.label}}</at-option>
            </at-select>
          </div>
          <div class="text-center fixedOptions">
            <button class="btn btn-primary">Próximo <img src="../../assets/images/angle-right.svg"></button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select"

export default {
  components: {
    vSelect
  },
  data() {
    return {
      optionsMarital : [
        {value: 1, label: 'Solteira(o)'},
        {value: 2, label: 'Casada(o)'},
        {value: 4, label: 'Divorciada(o)'},
        {value: 5, label: 'Viúva(o)'},
        {value: 6, label: 'União Estavel'}
      ]
    }
  },
  props: {
    currentUser: {required: true, type: Object}
  },
  methods: {
    onSubmit(e) {
      e.preventDefault()
      
      const newData = {Social: this.currentUser.Social}
      this.$emit('on-submit', newData)
    },
  },
  mounted() {
    document.getElementsByClassName("at-select__input")[0].setAttribute("required", "");
  }
}
</script>




// WEBPACK FOOTER //
// src/components/AdditionalInformationSocial/EstadoCivilStep.vue